<template>
  <p class="fs-sm fade-in" style="margin-bottom: 0.9em;">
    <router-link
      :to="link"
      class="theme-primary-color fw-semibold"
      style="color:#6D7175;"
    >
      <i class="fa fa-angle-left icon-sm mr-2"></i>{{ text }}
    </router-link>
  </p>
</template>

<script>
export default {
  props: {
    link: String,
    text: String,
  },
};
</script>
